import { gql } from '@apollo/client'

export const GET_ALL_ROUTES_POINTS = gql`
  query GetAllRoutePoints(
    $limit: Int
    $offset: Int
    $searchQuery: String
    $routeId: Int
    $waterStationId: Int
    $truckId: Int
    $loadedAt: String
    $deliveredAt: String
  ) {
    getAllRoutePoints(
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
      route_id: $routeId
      water_station_id: $waterStationId
      truck_id: $truckId
      loaded_at: $loadedAt
      delivered_at: $deliveredAt
    ) {
      count
      rows {
        id
        route_id
        water_station_id
        water_truck_request_id
        loaded_volume
        loaded_at
        delivered_at
        RoutePointsToRoute {
          id
          user_id
          truck_id
          provider_id
          scheduled_date
          frequency
          frequency_spanish
          RouteToUser {
            id
            first_name
            last_name
            name
          }
          RouteToTrucks {
            id
            plate_number
            type
            capacity
            status
          }
          RouteToProvider {
            id
            card_name
          }
        }
        RoutePointsToWaterStation {
          id
          name
          location
          address
          status
          operating_hours
          manager
          contact_info
        }
        RoutePointsToWaterTruckRequest {
          id
          status_id
          folio
          priority
          volume
          is_extemporaneous
          StatusOfWaterTruckRequest {
            name
            id
            progress
            color
          }
          AddressOfWaterTruckRequest {
            id
            address_full
          }
        }
      }
    }
  }
`

export const GET_ROUTE_POINT_BY_ID = gql`
  query GetRoutePointById($id: Int!) {
    getRoutePointById(id: $id) {
      id
      route_id
      water_station_id
      water_truck_request_id
      loaded_volume
      loaded_at
      delivered_at
      RoutePointsToRoute {
        id
        provider_id
        scheduled_date
        truck_id
        user_id
        frequency
        RouteToUser {
          id
          first_name
          last_name
          name
        }
        RouteToTrucks {
          id
          plate_number
          type
          capacity
          status
        }
        RouteToProvider {
          id
          card_name
        }
      }
      RoutePointsToWaterStation {
        id
        name
        location
        address
        status
        operating_hours
        manager
        contact_info
      }
      RoutePointsToWaterTruckRequest {
        id
        status_id
        folio
        priority
        volume
        StatusOfWaterTruckRequest {
          name
          id
        }
        AddressOfWaterTruckRequest {
          id
          address_full
        }
        AttachmentsOfWaterTruckRequest {
          id
          water_truck_request_id
          url
          type_file
          user_id_created
          UserOfWaterTruckRequestAttachment {
            id
            name
            id_role
            RoleOfUser {
              id
              role_name
            }
          }
        }
        UserOfWaterTruckRequest {
          id
          first_name
          last_name
          name
          email
          phone
        }
      }
    }
  }
`

export const CREATE_ROUTE_POINT = gql`
  mutation CreateRoutePoint($waterTruckRequest: [Int], $routeId: Int) {
    createRoutePoint(waterTruckRequest: $waterTruckRequest, routeId: $routeId)
  }
`

export const UPDATE_ROUTE_POINT = gql`
  mutation UpdateRoutePoint(
    $updateRoutePointId: Int!
    $routePointInput: routesPointsUpdateInput
  ) {
    updateRoutePoint(id: $updateRoutePointId, routePointInput: $routePointInput)
  }
`

export const DELETE_ROUTE_POINT = gql`
  mutation DeleteRoutePoint($id: Int!) {
    deleteRoutePoint(id: $id)
  }
`
export const CHANGE_ROUTE_POINT_STATUS = gql`
  mutation ChangeStatusRoutePoint(
    $changeStatusRoutePointId: Int!
    $routePoint: routesPointsInput
    $step: String
  ) {
    changeStatusRoutePoint(
      id: $changeStatusRoutePointId
      routePoint: $routePoint
      step: $step
    )
  }
`
